import { Iot } from "./iot";
import { Account } from "./account";
import { DataChart } from "./datachart";
import { codeUploader, firmwareUploader } from './uploader';
import { codeProcessor } from './codeProcessor';
import { UIProgess } from './UIProgress';
import { UIFirmware } from './UIFirmware';
import { SystemUi } from './UICore';
export default {
    Iot,
    Account,
    codeUploader,
    firmwareUploader,
    codeProcessor,
    UIProgess,
    DataChart,
    UIFirmware,
    SystemUi
};
